import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { CSSProperties, ReactNode } from 'react'

interface GovUKHintProps {
  children: ReactNode
  id?: string
  className?: string
  style?: CSSProperties
}

export function GovUKHint({ children, id, className, style }: GovUKHintProps) {
  const classes = ['govuk-hint', className].filter(Boolean).join(' ')

  return (
    <div className={classes} id={id} style={style}>
      {children}
    </div>
  )
}
